import { type FC } from 'react';
import {
  UiBox,
  type UiBoxProps, UiHStack, UiIconGlobe, UiIconHeadset,
  UiStack,
  uiStyles, UiText,
} from '@/lib/ui';
import AddonCard, { type AddonCardProps } from './AddonCard';
import BaseDividerHorizontal from '@/base/Divider/Horizontal';
import { type account } from '@/api';
import { getAddonsEnabled, isAddonEnabled } from '@/account/subscription/utils';
import { SubscriptionProduct } from '@/api/constant/subscription';
import PriceDisplay from '@/account/component/Subscription/PriceDisplay';
import MultiLingualSupportCard from '@/base/App/MultiLingualSupportCard';
import EventAppCard from '@/base/App/EventAppCard';
import { UiTooltip } from '@/lib/ui/Tooltip';

export interface ServicePack1Props extends UiBoxProps {
  subscription?: account.Subscription
  onToggle?: AddonCardProps['onToggle']
}

const ServicePack1: FC<ServicePack1Props> = ({
  onToggle = undefined,
  subscription = undefined,
  ...props
}) => {
  return (
    <AddonCard
      onToggle={onToggle}
      isEnabled={subscription ? isAddonEnabled(subscription, SubscriptionProduct.MultiLingualSupport) : false}
      {...props}
    >
      <UiStack spacing={0} borderRadius={uiStyles.borderRadius}>
        <UiHStack justifyContent={'space-between'}>
          <UiTooltip
            label={'Display event hub content in multiple languages'}
            borderRadius={uiStyles.borderRadius}
            p={2}
            px={4}
          >
            <UiBox {...uiStyles.hover}>
              <MultiLingualSupportCard />
            </UiBox>
          </UiTooltip>
          {subscription && (
            <PriceDisplay price={subscription.products[SubscriptionProduct.MultiLingualSupport].monthlyPrice * 3} suffix={' / 3 months'} />
          )}
        </UiHStack>
        {/* <BaseDividerHorizontal height={4} /> */}
        {/* <UiText variant='body1' color={'text.secondary'}>Display event hub content in multiple languages</UiText> */}
      </UiStack>
    </AddonCard>
  );
};

export default ServicePack1;
